import RegisterPage from "./RegisterPage";

export default RegisterPage;

export * from "./RegisterPage";
